
export const WEEKDAY = [
    {
      week: 'Domingo',
      acronym: 'Dom'
    }, 
    {
      week: 'Lunes',
      acronym: 'Lun'
    }, 
    {
      week: 'Martes',
      acronym: 'Mar'
    }, 
    {
      week: 'Miércoles',
      acronym: 'Mié'
    }, 
    {
      week: 'Jueves',
      acronym: 'Jue'
    }, 
    {
      week: 'Viernes',
      acronym: 'Vie'
    }, 
    {
      week:  'Sábado',
      acronym: 'Sáb'
    }
];

export const MONTHS = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
];

import router from '@/router';
export const ResourcesService = {
    checkErrors(responseData) {
      if (responseData.error) {
        const MSG = responseData.msg
        if (MSG === 'El token ya expiro o es invalido, intente iniciar sesion de nuevo. ') {
          setTimeout(() => {
            router.push('/login');
          }, 5000);
        }
      }
    },
    logout: function() {
        localStorage.removeItem('TIPO')
        localStorage.removeItem('TOKEN')
        localStorage.removeItem('DESPACHO')
        localStorage.removeItem('USERNAME')
        this.$router.push('/login')
    },
    getToken: function () {
        const TOKEN = localStorage.getItem('TOKEN')
        if (TOKEN === null || TOKEN === '' || TOKEN === undefined) {
            return null
        }

        return TOKEN
    },
    
    moneyFormat: function (money) {
      if (money === null ||  money === '' || money === undefined) {
        return money
      }

      let newFormat = '';
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });

      newFormat = formatter.format(money);
      return newFormat;
    },

    dateFormat: function(inputDate){
      if (!/^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
        throw new Error('La fecha debe estar en el formato aaaa-mm-dd');
      }

      const [year, month, day] = inputDate.split('-');

      const formattedDate = `${day}-${month}-${year}`;

      return formattedDate;
    }
}